import {
  checkIfUnrestrictedOpponentCounts,
  RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT,
} from '../../configs/rankMatch';

/**
 * Сводка ограничения по числу противников (configs/rankMatch.js) для
 * экрана настройки поиска и плашки экрана поиска: выбранные числа противников
 * (интервалом, если идут подряд, иначе перечислением) и итоговая длительность
 * матча — меньшая граница от наименьшего выбранного, большая от наибольшего.
 *
 * @param {number[]|null} opponentCounts
 * @returns {{opponentsText: string, durationText: string}|null} null — без ограничений
 */
export const getRankMatchOpponentCountsSummary = (opponentCounts) => {
  if (checkIfUnrestrictedOpponentCounts(opponentCounts)) {
    return null;
  }
  const sortedCounts = [...opponentCounts].sort((a, b) => a - b);
  const smallestCount = sortedCounts[0];
  const largestCount = sortedCounts[sortedCounts.length - 1];
  const isContiguousRange = sortedCounts.length > 1
    && largestCount - smallestCount === sortedCounts.length - 1;
  const countsText = isContiguousRange
    ? `${smallestCount} - ${largestCount}`
    : sortedCounts.join(', ');
  const [minMinutes] = RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT[smallestCount];
  const [, maxMinutes] = RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT[largestCount];
  return {
    opponentsText: `Противники: ${countsText}`,
    durationText: `Длительность матча: ${minMinutes} - ${maxMinutes} минут`,
  };
};
